import React, { useState, useEffect } from 'react';
import { Image, Modal } from 'react-bootstrap';
import ReactTable, { DateRangeFilter, filterDateRange } from '../../../../ReactTable/ReactTable';
import popupIcon from '../../../../../../assets/images/Popup-Icons/PopupIcons_AssetTagIcon.svg';
import { X } from 'lucide-react';
import { convertToBaseFormatDate } from '../../../../../../commonservices/CommonMethods';
import NoDataFound from '../../TableComponents/NoDataFound/NoDataFound';



const TagsHistoryPopup = (props) => {
    
    const [columns, setColumns] = useState([]);
    const [tableData, setTableData] = useState([]);
    useEffect(() => {
        setColumns([
            {
                Header: `${props.tagName} Status`,
                accessor: 'status',
                filter: '',
                Cell: props => <React.Fragment>
                    <span>{props.value}</span>
                </React.Fragment>

            },
            {
                Header: 'Updated At',
                accessor: row => convertToBaseFormatDate(row?.updatedAt, true, true),
                filter: filterDateRange,
                Filter: DateRangeFilter,
                restrictInput: true,
                Cell: props => props.value ?
                    <span> {props.value}
                    </span> : ''

            },
            {
                Header: 'Updated By',
                accessor: 'updatedByName',
                filter: '',
                Cell: props => <React.Fragment>
                    <span className='d-block'>{props.value}</span>
                </React.Fragment>

            },
            {
                Header: 'Notes',
                accessor: row => row?.notes ? row?.notes : row?.comments ? row?.comments : row?.completedNotes ? row?.completedNotes : "",
                filter: '',
                Cell: props => <React.Fragment>
                    <span className='d-block'>{props.value ? props.value : '-NA-'}</span>
                </React.Fragment>

            },

        ])
    }, [tableData])


    useEffect(() => {
        setTableData(props.data)
    }, [props.data])

    return (
        <Modal className={`default-popup modal-backdrop-bg-color default-medium-popup`} show={props.showModal}
            onHide={props.onClose} backdrop={props.isStatic ? "static" : null} centered={props.centered}>
            <Modal.Header className='darkblue-bg-color' closeButton={props.isStatic ? false : true}>
                <Modal.Title>
                    {props.icon ? props.icon : <span className='popup-title-icon'><Image src={popupIcon} /></span>}
                    <span className='flex-grow-1'>{props.modalTitle ? props.modalTitle : `${props.tagName} History`}</span>
                    <span className='popup-close-icon'><X size={20} /></span>
                </Modal.Title>
            </Modal.Header>

            <Modal.Body className='p-0'>
                {tableData && tableData.length > 0 ?
                    <ReactTable
                        columns={columns}
                        data={tableData}
                    />
                    :
                    <NoDataFound />
                }
            </Modal.Body>
        </Modal>
    )

}

export default TagsHistoryPopup;